import addTargetEventListener from '../events/addTargetEventListener';
import forEachSelector from '../elements/forEachSelector';
import 'element-closest-polyfill';

function closeBio(textBox) {
  textBox.style.display = 'none';
}

function removeMarginBottom(card) {
  card.style.removeProperty('margin-bottom');
}

function addDeselectedClass(image) {
  image.classList.add('image-card__image--deselected');
  image.classList.remove('image-card__image--selected');
}

function addSelectedClass(image) {
  image.classList.add('image-card__image--selected');
  image.classList.remove('image-card__image--deselected');
}

function removeSelectedClasses(image) {
  image.classList.remove('image-card__image--deselected');
  image.classList.remove('image-card__image--selected');
}

function setupCardButton(event) {
  const card = event.target.closest('.employee-block .card--clickable');
  const employeeBio = card.querySelector('.employee-block .employee-bio');
  const selectedImage = card.querySelector('.employee-block .image-card__image');
  event.stopPropagation();
  forEachSelector('.employee-block .employee-bio', closeBio);
  forEachSelector('.employee-block .card--clickable', removeMarginBottom);
  forEachSelector('.employee-block .image-card__image', addDeselectedClass);

  // since we added the deselected class to all image cards inlcuding the selected one
  // we need to remove the deselected class first before adding selected class
  addSelectedClass(selectedImage);

  employeeBio.style.display = 'block';
  // get the height of the employee bio box and add it as a margin bottom for
  // its parent card for expanding
  const employeeBioHeight = employeeBio.offsetHeight;
  card.style.marginBottom = employeeBioHeight + 25 + 'px';
  // get the height of the parent card and add it as a margin top for the employee bio box
  // so it would expand under the relevant card
  const cardHeight = card.offsetHeight;
  employeeBio.style.marginTop = cardHeight + 25 + 'px';
}

function setupCloseButton(event) {
  event.stopPropagation();
  forEachSelector('.employee-block .employee-bio', closeBio);
  forEachSelector('.employee-block .card--clickable', removeMarginBottom);
  forEachSelector('.employee-block .image-card__image', removeSelectedClasses);
}

function setupLinkedInButton(event) {
  event.stopPropagation();
}

addTargetEventListener('click', '.employee-block .card--clickable', setupCardButton);
addTargetEventListener('click', '.employee-block .employee-bio__close-button', setupCloseButton);
addTargetEventListener('click', '.employee-block .employee-bio__icon', setupLinkedInButton);
